import React, { useState } from 'react';
import { Button } from '../../../components/base/Button';

const GallerySection: React.FC = () => {
  const [selectedImage, setSelectedImage] = useState<string | null>(null);

  const galleryItems = [
    {
      before: "https://public.readdy.ai/ai/img_res/463662b203938b7ecb919c7e97ac945d.jpg",
      after: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/9ac1c7159bd4f519fd6a1eb38f3294a8.jpeg",
      title: "Residential Home Transformation",
      description: "From clogged disaster to worry-free protection"
    },
    {
      before: "https://readdy.ai/api/search-image?query=Commercial%20building%20gutters%20completely%20blocked%20with%20leaves%20and%20debris%2C%20water%20damage%20visible%20on%20building%20exterior%2C%20expensive%20maintenance%20problems%2C%20professional%20property%20management%20issues&width=600&height=400&seq=gallery-before-002&orientation=landscape",
      after: "https://static.readdy.ai/image/8f86aa673083729b29d3e3ce11202afe/d320fef5c6edb1280e412a4f705a9b7a.jpeg",
      title: "Commercial Property Protection",
      description: "Large-scale gutter protection solution"
    },
    {
      before: "https://readdy.ai/api/search-image?query=Homeowner%20dangerously%20cleaning%20gutters%20on%20tall%20ladder%2C%20safety%20hazard%20situation%2C%20difficult%20gutter%20maintenance%2C%20risky%20home%20maintenance%20work%2C%20person%20struggling%20with%20clogged%20gutters&width=600&height=400&seq=gallery-before-003&orientation=landscape",
      after: "https://readdy.ai/api/search-image?query=Happy%20homeowner%20standing%20on%20ground%20looking%20up%20at%20house%20with%20satisfied%20smile%2C%20no%20ladder%20needed%2C%20GutterBrush%20installed%20gutters%20visible%2C%20safe%20and%20worry-free%20home%20maintenance%2C%20content%20homeowner%20admiring%20protected%20home%20from%20ground%20level&width=600&height=400&seq=gallery-after-003&orientation=landscape",
      title: "Safety First Installation",
      description: "Eliminate dangerous ladder climbing forever"
    },
    {
      before: "https://readdy.ai/api/search-image?query=Water%20damage%20to%20home%20foundation%20from%20clogged%20gutters%2C%20basement%20flooding%2C%20expensive%20repair%20bills%2C%20foundation%20cracks%2C%20costly%20water%20damage%20restoration%20work&width=600&height=400&seq=gallery-before-004&orientation=landscape",
      after: "https://readdy.ai/api/search-image?query=Protected%20home%20foundation%20with%20proper%20gutter%20drainage%2C%20dry%20basement%2C%20no%20water%20damage%2C%20effective%20gutter%20protection%20preventing%20costly%20repairs%2C%20well-maintained%20property&width=600&height=400&seq=gallery-after-004&orientation=landscape",
      title: "Foundation Protection Success",
      description: "Preventing expensive water damage"
    }
  ];

  return (
    <section id="gallery" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-800 mb-4">
            GutterBrush Before & After Gallery
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            See the dramatic transformation from clogged, dangerous gutters to worry-free protection. 
            Real results from real customers.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {galleryItems.map((item, index) => (
            <div key={index} className="bg-white rounded-lg shadow-lg overflow-hidden">
              <div className="grid grid-cols-2">
                <div className="relative">
                  <img 
                    src={item.before}
                    alt="Before GutterBrush"
                    className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={() => setSelectedImage(item.before)}
                  />
                  <div className="absolute bottom-2 left-2 bg-red-500 text-white px-2 py-1 rounded text-sm font-medium">
                    Before
                  </div>
                  <div className="absolute top-2 right-2 bg-black/50 rounded-full p-2 cursor-pointer">
                    <i className="ri-search-line text-white"></i>
                  </div>
                </div>
                <div className="relative">
                  <img 
                    src={item.after}
                    alt="After GutterBrush"
                    className="w-full h-48 object-cover cursor-pointer hover:opacity-90 transition-opacity"
                    onClick={() => setSelectedImage(item.after)}
                  />
                  <div className="absolute bottom-2 left-2 bg-green-500 text-white px-2 py-1 rounded text-sm font-medium">
                    After
                  </div>
                  <div className="absolute top-2 right-2 bg-black/50 rounded-full p-2 cursor-pointer">
                    <i className="ri-search-line text-white"></i>
                  </div>
                </div>
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-gray-800 mb-2">{item.title}</h3>
                <p className="text-gray-600 mb-4">{item.description}</p>
                <Button variant="outline" size="sm">
                  View Full Project
                </Button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a href="https://www.gutterbrush.com/pages/gutter-guard-reviews" target="_blank" rel="noopener noreferrer">
            <Button size="lg">
              Read Customer Reviews
            </Button>
          </a>
        </div>
      </div>

      {/* Image Modal */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-50 p-4">
          <div className="relative max-w-4xl max-h-full">
            <img 
              src={selectedImage}
              alt="Gallery Image"
              className="max-w-full max-h-full object-contain"
            />
            <button
              className="absolute top-4 right-4 bg-white rounded-full p-2 hover:bg-gray-100"
              onClick={() => setSelectedImage(null)}
            >
              <i className="ri-close-line text-gray-800 text-xl"></i>
            </button>
          </div>
        </div>
      )}
    </section>
  );
};

export default GallerySection;
